import { Theme } from '@mui/material';
import { Products } from './getProductLevel';

const determineActiveColor = (theme: Theme, product?: Products): string => {
  switch (product) {
    case Products.Flow:
      return '#009fe3';

    case Products.MyPortal:
      return '#21D0B2';

    case Products.Fusion:
      return '#C04CFD';

    case Products.Quantum:
      return '#32cd32';

    default:
      return theme.palette.mode === 'light' ? theme.palette.info.main : theme.palette.info.light;
  }
};

export default determineActiveColor;
